export const MINI_QUALITY = 'miniQuality';
export const ECO_QUALITY = 'ecoQuality';
export const STANDARD_QUALITY = 'standardQuality';
export const SUPERIOR_QUALITY = 'superiorQuality';
export const AUTOMATIC_QUALITY = 'automaticQuality';
export const LABEL_ECO_QUALITY = 'Éco';

export const QUALITY_MAP = new Map()
  .set(MINI_QUALITY, {
    label: 'Mini',
    getDescription: () => 'Qualité minimale pour les connexions instables sur mobile'
  })
  .set(ECO_QUALITY, {
    label: LABEL_ECO_QUALITY,
    getDescription: () => 'Qualité standard pour réduire l\'utilisation des données',
    icon: 'eco',
    iconActive: 'eco-activated'
  })
  .set(STANDARD_QUALITY, {
    label: 'Supérieure',
    getDescription: (useAlt) => (useAlt ? 'Meilleure qualité disponible' : 'Qualité Haute Définition')
  })
  .set(SUPERIOR_QUALITY, {
    label: 'Maximale',
    getDescription: () => 'Qualité full Haute Définition'
  });
